import { DataSourceFields } from 'interfaces/api/dataSourceFields.interfaces'

export const dataSourceFieldsMapper = (data: DataSourceFields[]): string[] =>
  data.reduce(
    (acc, { templateFields }) => [
      ...acc,
      ...(!Array.isArray(templateFields) ? [] : templateFields.map(({ code }) => code)),
    ],
    [] as string[],
  )
